import { A as y } from "./LoyaltyBenefits-BsOC5pY_.js";
import { a as Y, b as q, p as K, F as z, d as J, L as O, c as X, Q as Z, R as N, e as M, q as ee, S as te, r as re, V as ae, f as ie, g as se, i as oe, u as ne, h as fe, j as ce, k as ue, l as le, m as de, n as ge, o as me } from "./LoyaltyBenefits-BsOC5pY_.js";
import { jsx as c } from "react/jsx-runtime";
import { useState as A, useEffect as k, Suspense as F } from "react";
import { useConfig as S } from "@intergamma/config";
import { DialogBottomSheet as V, DialogExtended as L } from "@intergamma/dialog";
import { useActiveVariant as D } from "@intergamma/experiments/hooks";
import { useTranslation as w } from "react-i18next";
import { toast as E } from "react-toastify";
import { u as R } from "./useAuthenticate-Dx2rWWSX.js";
import { c as pe, g as Pe } from "./useAuthenticate-Dx2rWWSX.js";
import { I as Ce, c as ye, a as Ae, g as ke, w as Fe } from "./index-C2EW4nef.js";
import { l as Ve } from "./index-X2k_3Mmo.js";
import { u as De } from "./useTrackLoggedIn-BijpUfLQ.js";
function j({
  trigger: r,
  initLocation: e,
  loading: l = !1,
  onLogin: i,
  onLoyaltyLogin: s,
  loginWall: o = !1,
  setShowLoginWall: t,
  onMount: a
}) {
  const { t: d } = w("ig-header"), { authenticate: m, isLoading: x, error: p } = R(
    "loginHeader",
    !1
  ), P = D("abtest_drl_3890-dba_4"), { isMobile: g } = S(), [h, f] = A(!1), C = g ? V : L;
  return k(() => a == null ? void 0 : a({ onOpenChange: f }), [a]), /* @__PURE__ */ c(
    C,
    {
      open: h,
      onOpenChange: (n) => {
        !n && o && g && P === "B-login" && (window.location.href = "/n"), n || t == null || t(!1), f(n);
      },
      trigger: r,
      dialogTitle: d("Login"),
      children: /* @__PURE__ */ c(F, { fallback: null, children: /* @__PURE__ */ c(
        y,
        {
          errorMessage: p,
          onLogin: async (n) => {
            await m(n), f(!1), await i(), E.success(d("loginSuccess"));
          },
          isLoading: x || l,
          onClose: () => f(!1),
          initLocation: e,
          loyaltyCardLogin: s,
          loginWall: o
        }
      ) })
    }
  );
}
const u = [
  { country: "NL", prefix: "+31", altPrefix: "0031", trunkPrefix: "0" },
  // The Netherlands
  { country: "BE", prefix: "+32", altPrefix: "0032", trunkPrefix: "0" },
  // Belgium
  { country: "DE", prefix: "+49", altPrefix: "0049", trunkPrefix: "0" },
  // Germany
  { country: "FR", prefix: "+33", altPrefix: "0033", trunkPrefix: "0" },
  // France
  { country: "LU", prefix: "+352", altPrefix: "00352", trunkPrefix: null }
  // Luxembourg
], Q = (r, e) => {
  var o;
  if (u.some(
    ({ prefix: t }) => e.startsWith(t)
  ))
    return e;
  const i = u.find(
    ({ altPrefix: t }) => e.startsWith(t)
  );
  if (i)
    return e.replace(
      i.altPrefix,
      i.prefix
    );
  const s = ((o = u.find(
    ({ prefix: t, altPrefix: a }) => t === r || a === r
  )) == null ? void 0 : o.trunkPrefix) || null;
  return s && e.startsWith(s) ? `${r}${e.slice(s.length)}` : `${r}${e}`;
};
export {
  y as Account,
  Y as AccountContext,
  q as AccountProvider,
  j as AuthDialog,
  K as Flow,
  z as ForgotPasswordForm,
  Ce as IG_APP_AUTH,
  J as LoginForm,
  O as LoyaltyBenefits,
  X as LoyaltyCardForm,
  Z as QUERY_KEY,
  N as ResendSuccess,
  M as ResendVerification,
  ee as Section,
  te as SignUpForm,
  re as VerificationMethod,
  ae as VerifyForm,
  ie as VerifySuccess,
  pe as configureAuth,
  ye as createHttpClient,
  Pe as getAuthConfiguration,
  Ae as getHeaders,
  ke as getIdToken,
  se as getUrls,
  oe as initialState,
  Q as joinPhoneNumber,
  Ve as log,
  ne as useAccount,
  fe as useAccountQuery,
  R as useAuthenticate,
  ce as useDownloadAppleWalletCard,
  ue as useDownloadGoogleWalletCard,
  le as useResendVerification,
  de as useSignUp,
  De as useTrackLoggedIn,
  ge as useVerificationCodeForm,
  me as useVerifyCode,
  u as verificationPhoneFormats,
  Fe as withCancelToken
};
